import { Wrench } from 'lucide-react';
import ImportWizard from '../../component/import/ImportWizard';

// Colunas reais aceitas por `POST /services/import` (service/importer.go) —
// nomes/obrigatoriedade extraídos da validação do backend, não do mock do
// protótipo de produtos. Diferente de `/stock/import`, o importador de
// serviços só valida `nome_servico` como obrigatório (linha vazia gera
// "nome do serviço é obrigatório") e checa duplicidade de nome dentro do
// próprio CSV e contra serviços já cadastrados (`IsCheckServiceExists`).
// `descricao`, `valor` e `generico` não têm checagem de obrigatoriedade no
// handler: `valor` vazio é tratado como "0,00" (`money.ParseMoneyFromString`
// aceita string vazia), mas um valor não-numérico faz `money.NewMoneyFromString`
// entrar em pânico (bug pré-existente do backend, fora do escopo desta
// tarefa) — por isso o exemplo do modelo usa sempre um decimal válido.
// `generico` só é considerado verdadeiro quando o valor da célula é
// exatamente a string minúscula "sim" (comparação sensível a maiúsculas,
// outro comportamento herdado do backend, não corrigido aqui).
// `servico_externo` e `preco_custo_externo` existem no CSV modelo (espelhando
// as colunas da exportação) mas são ignoradas pelo importador: todo serviço
// importado em lote é sempre gravado como não-terceirizado com custo externo
// zero (`IsExternal: false`, `ExternalPrice: "0"` em `parseDataImport`).
const TEMPLATE_COLUMNS = [
    { key: 'nome_servico', required: true, type: 'Texto', example: 'Troca de óleo' },
    { key: 'descricao', required: false, type: 'Texto', example: 'Troca de óleo do motor e filtro' },
    { key: 'valor', required: false, type: 'Decimal', example: '89,90' },
    { key: 'generico', required: false, type: 'Texto (sim/não)', example: 'não' },
    { key: 'servico_externo', required: false, type: 'Texto (ignorado na importação)', example: 'não' },
    { key: 'preco_custo_externo', required: false, type: 'Decimal (ignorado na importação)', example: '0,00' },
];

const PREVIEW_HEADERS = ['nome_servico', 'descricao', 'valor', 'generico'];
const PREVIEW_ROWS = [
    ['Troca de óleo', 'Troca de óleo do motor e filtro', '89,90', 'não'],
    ['Alinhamento e balanceamento', '', '120,00', 'não'],
    ['Diagnóstico eletrônico', 'Verificação computadorizada de falhas', '0,00', 'sim'],
];

export default function Import() {
    return (
        <ImportWizard
            pageIcon={Wrench}
            pageTitle="Importar serviços"
            pageDescription="Cadastre vários serviços de uma vez a partir de uma planilha CSV."
            backTo="/services"
            backLabel="Voltar para serviços"
            templateHref="/servicos.csv"
            templateFileName="modelo_importacao_servicos.csv"
            templateColumns={TEMPLATE_COLUMNS}
            previewHeaders={PREVIEW_HEADERS}
            previewRows={PREVIEW_ROWS}
            importEndpoint={(separator) => `/services/import?comma=${separator}`}
            entityLabelPlural="serviços"
            mobileTip="Não repita nomes: nomes duplicados (na planilha ou já cadastrados) impedem a importação."
        />
    );
}
